import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cityNames", "specialtyIds", "maxDoctors", "onlyWithoutDoctors", "estimationContainer", "totalCost", "numCities", "numSpecialties", "maxEnrichment", "calculationFormula"]
  static values = {
    url: String,
    formulaTemplate: String,
    confirmationTemplate: String
  }

  connect() {
    this.estimate()
    
    // Suporte para Select2/super_select do Bullet Train
    // O Bullet Train dispara eventos nativos com prefixo '$' para eventos do Select2
    this.reissueListener = () => {
      // Usar setTimeout para garantir que o valor do select foi atualizado antes de ler
      setTimeout(() => this.estimate(), 0)
    }
    
    this.element.addEventListener("$select2:select", this.reissueListener)
    this.element.addEventListener("$select2:unselect", this.reissueListener)
    this.element.addEventListener("$change", this.reissueListener)

    if (window.jQuery) {
      this.jQueryListener = () => {
        // Usar setTimeout para garantir que o valor do select foi atualizado antes de ler
        setTimeout(() => this.estimate(), 0)
      }
      window.jQuery(this.specialtyIdsTarget).on('change.select2 change select2:select select2:unselect', this.jQueryListener)
    }
  }

  disconnect() {
    this.element.removeEventListener("$select2:select", this.reissueListener)
    this.element.removeEventListener("$select2:unselect", this.reissueListener)
    this.element.removeEventListener("$change", this.reissueListener)

    if (window.jQuery) {
      window.jQuery(this.specialtyIdsTarget).off('change.select2 change select2:select select2:unselect', this.jQueryListener)
    }
  }

  estimate() {
    const cityNames = this.cityNamesTarget.value
    // Use specialtyIdsTarget directly to get values for both standard and super-selects
    const specialtyIds = Array.from(this.specialtyIdsTarget.options || [])
      .filter(option => option.selected)
      .map(option => option.value)
      .filter(value => value !== "")

    const maxDoctors = this.maxDoctorsTarget.value || 5
    const onlyWithoutDoctors = this.onlyWithoutDoctorsTarget.checked

    const params = new URLSearchParams()
    params.append("city_names", cityNames)
    specialtyIds.forEach(id => params.append("specialty_ids[]", id))
    params.append("max_doctors", maxDoctors)
    params.append("only_without_doctors", onlyWithoutDoctors)

    fetch(`${this.urlValue}?${params.toString()}`, {
      headers: {
        "Accept": "application/json"
      }
    })
    .then(response => response.json())
    .then(data => {
      this.totalCost = data.total_cost
      this.totalCostTarget.textContent = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.total_cost)
      this.numCitiesTarget.textContent = data.num_cities
      this.numSpecialtiesTarget.textContent = data.num_specialties
      this.maxEnrichmentTarget.textContent = data.max_doctors_to_enrich
      
      const currencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
      
      let formula = this.formulaTemplateValue || ""
      if (formula) {
        formula = formula
          .replaceAll("%{num_cities}", data.num_cities)
          .replaceAll("%{num_specialties}", data.num_specialties)
          .replaceAll("%{num_searches}", data.num_searches)
          .replaceAll("%{search_unit}", currencyFormatter.format(data.unit_costs.search))
          .replaceAll("%{max_doctors}", maxDoctors)
          .replaceAll("%{total_enrich}", data.max_doctors_to_enrich)
          .replaceAll("%{enrich_unit}", currencyFormatter.format(data.unit_costs.enrichment))
      }

      this.calculationFormulaTarget.textContent = formula
      this.estimationContainerTarget.classList.remove("hidden")
    })
  }

  confirm(event) {
    if (this.totalCost === undefined || !this.hasConfirmationTemplateValue) return;

    const formattedCost = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.totalCost)
    const message = this.confirmationTemplateValue.replace("%{cost}", formattedCost)

    if (!window.confirm(message)) {
      event.stopImmediatePropagation()
      event.preventDefault()
    }
  }
}
